<!-- =========================================================================================
  File Name: TicketList.vue
  Description: Ticket List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ TicketData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : TicketData.length }} of {{ TicketData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD Ticket-->
        <vs-button type="gradient mr-4" v-on:click="addTicket">Add New</vs-button>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="TicketData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
    <vs-popup class="holamundo customnewpopup" :title="`${ticket_data && ticket_data.Id ? 'Edit' : 'Add'} Registration Type`" :active.sync="popupTicketPopup">
      <vx-card v-if="ticket_data">
        <ticket-edit-tab-info :data="ticket_data" v-on:reloadGrid="reloadGrid" />
      </vx-card>
    </vs-popup>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import ls from "@/common/localStorage"

// Store Module
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleTicketManagement from "@/store/ticket-management/moduleTicketManagement.js";

// Cell Renderer
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import TicketEditTabInfo from "./TicketEditTabInfo.vue";

//console.log(db);
//const event_collectionName = 'sayek-dev';

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererStatus,
    CellRendererActions,
    TicketEditTabInfo
  },
  data() {
    return {
      // Filter Options
      role: null,
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],

      searchQuery: "",
      popupTicketPopup: false,
      ticket_data: null,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          headerName: "ID",
          field: "Id",
          filter: true,
          width: 60
        },
        {
          headerName: "Registration Type",
          field: "RegistrationType",
          filter: true,
          width: 250
        },
        {
          headerName: "Min Limit",
          field: "MinLimit",
          filter: true,
          width: 120
        },
        {
          headerName: "Max Limit",
          field: "MaxLimit",
          filter: true,
          width: 120
        },
        {
          headerName: "Status",
          field: "Status",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "Visibility",
          field: "Visibility",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "Action",
          field: "transactions",
          width: 150,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: params => {
            return { id: params.data.RegistrationTypeId };
          }
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererStatus,
        CellRendererActions
      }
    };
  },
  watch: {
  },
  computed: {
    TicketData() {
      return this.$store.state.TicketManagement.tickets;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    addTicket() {
      //this.$router.push("/event/addticket").catch(() => {});
      this.fetch_ticket_data(null);      
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    fetch_ticket_data(Id) {
      if (Id === undefined) {
        Id = null;
      }
      this.ticket_data = null;
      this.$vs.loading();
      this.$store
        .dispatch("TicketManagement/fetchRegistrationType", Id)
        .then(res => {
          this.ticket_data = res.data;
          this.popupTicketPopup = true;
          this.$vs.loading.close();
        })
    },
    reloadGrid(){
      this.popupTicketPopup = false;
      this.ticket_data = null;
      this.$store.dispatch("TicketManagement/fetchRegistrationTypes");
    }
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    this.$root.$on('fetch_ticket_data', this.fetch_ticket_data);
  },
  created() {
    if (!moduleTicketManagement.isRegistered) {
      this.$store.registerModule("TicketManagement", moduleTicketManagement);
      moduleTicketManagement.isRegistered = true;
    }
    this.$store.dispatch("TicketManagement/fetchRegistrationTypes").catch(err => {
      console.error(err)
    });
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>